import { Box, Stack, SvgIcon, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import DateIcon from '../../../../../assets/svg/finalReport/details/CalendarCheck.svg?react';
import SeverityIcon from '../../../../../assets/svg/finalReport/details/ChartLine.svg?react';
import TypeIcon from '../../../../../assets/svg/finalReport/details/clipboard.svg?react';
import ReferenceIcon from '../../../../../assets/svg/finalReport/details/File.svg?react';
import CaseManagerIcon from '../../../../../assets/svg/finalReport/details/UserSquare.svg?react';
import { FinalReportDocument } from '../../../../../interfaces/FinalReportDocument';
import { FixedFinalReportDetails } from '../../../../../interfaces/FixedFinalReportDetails';
import DownloadFinalReportButton from '../../../../common/finalReport/downloadReportButton';

type ItemType = {
  id: number;
  report: string;
  name: string;
  associatedDepartment: string;
  notificationReason: string;
  dateInformed: string;
};

interface ModifiedFinalReportDocument extends FinalReportDocument {
  informed_individuals: Array<ItemType>;
  has_informed_individuals: boolean;
}

interface FixedDetailsProps {
  title: string;
  values: FixedFinalReportDetails;
  documentData: ModifiedFinalReportDocument;
  caseID: string;
}

const FixedDetails = ({
  title,
  values,
  documentData,
  caseID,
}: FixedDetailsProps) => (
  <Box width='100%'>
    <Stack direction='row' justifyContent='space-between' width='100%'>
      <Typography fontSize={24}>{title}</Typography>
      <DownloadFinalReportButton pdfData={documentData} />
    </Stack>
    <Stack spacing={2} marginTop='20px' marginBottom='24px'>
      {values.assignee && (
        <Stack direction='row' width='100%' spacing={2}>
          <Stack direction='row' width={175} spacing={1}>
            <SvgIcon
              component={CaseManagerIcon}
              inheritViewBox
              htmlColor='transparent'
            />
            <Typography color='#878787'>
              <FormattedMessage defaultMessage='Case Manager' />
            </Typography>
          </Stack>
          <Typography>{values.assignee}</Typography>
        </Stack>
      )}
      {values.dateReceived && (
        <Stack direction='row' width='100%' spacing={2}>
          <Stack direction='row' width={175} spacing={1}>
            <SvgIcon
              component={DateIcon}
              inheritViewBox
              htmlColor='transparent'
            />
            <Typography color='#878787'>
              <FormattedMessage defaultMessage='Date Received' />
            </Typography>
          </Stack>
          <Typography>{values.dateReceived}</Typography>
        </Stack>
      )}
      {values.referenceID && (
        <Stack direction='row' width='100%' spacing={2}>
          <Stack direction='row' width={175} spacing={1}>
            <SvgIcon
              component={ReferenceIcon}
              inheritViewBox
              htmlColor='transparent'
            />
            <Typography color='#878787'>
              <FormattedMessage defaultMessage='Report Reference' />
            </Typography>
          </Stack>
          <Typography>
            <Link to={`/customer/reports/${caseID}`}>{values.referenceID}</Link>
          </Typography>
        </Stack>
      )}
      {values.reportType && (
        <Stack direction='row' width='100%' spacing={2}>
          <Stack direction='row' width={175} spacing={1}>
            <SvgIcon
              component={TypeIcon}
              inheritViewBox
              htmlColor='transparent'
            />
            <Typography color='#878787'>
              <FormattedMessage defaultMessage='Report Type' />
            </Typography>
          </Stack>
          <Typography>{values.reportType}</Typography>
        </Stack>
      )}
      {values.priority && (
        <Stack direction='row' width='100%' spacing={2}>
          <Stack direction='row' width={175} spacing={1}>
            <SvgIcon
              component={SeverityIcon}
              inheritViewBox
              htmlColor='transparent'
            />
            <Typography color='#878787'>
              <FormattedMessage defaultMessage='Report Severity' />
            </Typography>
          </Stack>
          <Typography>{values.priority}</Typography>
        </Stack>
      )}
    </Stack>
  </Box>
);

export default FixedDetails;
